import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackeroneComponent } from './simple-icons-hackerone.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackeroneComponent ],
    exports:      [ SimpleIconsHackeroneComponent ],
    bootstrap:    []
})
export class SimpleIconsHackeroneModule {}
